/**
 * Gallery JS controller.
 */

import fancybox from '@fancyapps/fancybox';

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Gallery
 */
export default class Gallery {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$galleryImages           = $( '#js-gallery-images' );
        this.$galleryCategoriesFilter = $( '#js-gallery-categories-filter' );
        this.$galleryCategories       = $( '#js-gallery-categories' );
        this.$galleryCategory         = $( '.js-gallery-category' );
        this.$galleryCategoryAll      = $( '#js-gallery-category-all' );
        this.$gallerySpinner          = $( '#js-gallery-spinner' );
        this.$loadMore                = $( '#js-gallery-load-more' );
        this.$loadMoreText            = $( '#js-gallery-load-more-text' );
        this.$loadMoreSpinner         = $( '#js-gallery-load-more-spinner' );
        this.offset                   = 0;
        this.slug                     = window.location.hash.replace( '#', '' );
        this.darkOverlay              = $( '#js-dark-overlay' );
    }

    /**
     * All common events
     */
    events() {

        // Handle filters dropdown click.
        this.$galleryCategoriesFilter.on( 'click', ( e ) => {
            this.toggleFilters();
        });

        // Handle single category click.
        this.$galleryCategory.on( 'click', ( e ) => {
            e.preventDefault();

            // Get the slug from clicked category.
            const slug = $( e.target ).data( 'slug' );

            // If slug found, add it to url so we can easily link into specifi gallery category.
            // Otherwise remove hash from the url.
            if ( slug ) {
                window.location.hash = slug;
            } else {
                history.replaceState( null, null, ' ' );
            }

            // If slug is not the same as the current slug, handle offset, spinners, image loading etc.
            if ( slug !== this.slug ) {
                this.offset = 0;
                this.$galleryImages.empty();
                this.$loadMore.hide();
                this.$gallerySpinner.show();

                this.loadImagesByCategory( slug );
                this.toggleActiveCategory( slug );
            }
        });

        // Handle load more button click.
        this.$loadMore.on( 'click', ( e ) => {
            this.toggleLoadMoreBtn();
            this.loadImagesByCategory( this.slug );
        });
    }

    /**
     * Toggle filters menu.
     */
    toggleFilters() {

        // Toggle categories filters.
        this.$galleryCategories.toggleClass( 'open' );

        // Toggle dark overlay class.
        this.darkOverlay.toggleClass( 'menu--open' );
    }

    /**
     * Load images by slug.
     *
     * @param {string} slug Slug.
     */
    loadImagesByCategory( slug ) {
        this.slug = slug;

        dp( 'PageGallery/Images', {
            partial: 'gallery-images',
            tidy: true,
            data: true,
            bypassMainQuery: false,
            args: {
                'slug': slug,
                'offset': this.offset
            }
        }).then( ( response ) => {
            this.handleSuccess( response.success, response.data );
        }).catch( ( error ) => {
            this.handleError( error );
        });
    }

    /**
     * Handles successful DustPress JS request.
     *
     * @param {string} renderData Rendered data returned from a DustPress JS ajax request.
     * @param {object} data Data returned from a DustPress JS ajax request.
     */
    handleSuccess( renderData, data ) {

        // Return early if there's no posts.
        if ( ! data.posts ) {
            return;
        }

        // Increase the offset.
        this.offset += data.posts.length;

        // Append new images.
        this.$galleryImages.append( renderData );

        // Hide the spinner.
        this.$gallerySpinner.hide();

        // Toggle load more button state.
        this.toggleLoadMoreBtn();

        // Hide load more button if needed.
        if ( this.$galleryImages.children().length >= data.found_posts ) {
            this.$loadMore.hide();
        } else {
            this.$loadMore.css({ 'display': 'block' });
        }

        // We have to initialize Fancybox in here, because gallery images are loadead with AJAX.
        this.$fancyBoxGroup = $( '.js-fancy-box-group' );

        this.$fancyBoxGroup.fancybox({
            hash: false,
            infobar: true,
            buttons: [
                'close'
            ],
            baseTpl:
                '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                '<div class="fancybox-bg"></div>' +
                '<div class="fancybox-inner">' +
                '<div class="fancybox-toolbar">{{buttons}}</div>' +
                '<div class="fancybox-stage"></div>' +
                '<div class="fancybox-infobar"><strong>Kuva</strong> <span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
                '<div class="fancybox-navigation">{{arrows}}</div>' +
                '</div>' +
                '</div>',
            afterLoad: function( instance, current ) {

                const externalLink = current.opts.url;

                if ( typeof externalLink !== 'undefined' ) {
                    $( current.$content ).wrapInner( '<a href="' + externalLink + '" target="_blank" rel="noopener noreferrer"></a>' );

                    $( current.$image ).after( '<span class="external-link-icon"></span>' );
                }

                if ( current.opts.caption ) {
                    const $div = $( '<div>' ).addClass( 'fancybox-custom-caption' ).text( current.opts.caption );

                    if ( current.opts.translation_kuvateksti ) {
                        const $span = $( '<span>' ).text( current.opts.translation_kuvateksti + ' ' );
                        $div.prepend( $span );
                    }

                    current.$content.append( $div );
                }
            }
        });
    }

    /**
     * Handles failed DustPress JS request.
     *
     * @param {mixed} error Error returned from by failed DustPress JS request.
     */
    handleError( error ) {
        console.error( error );

        // Hide the spinner.
        this.$gallerySpinner.hide();

        // Toggle load more button state.
        this.toggleLoadMoreBtn();
    }

    /**
     * Handles active category toggle.
     *
     * @param {string} slug Current slug.
     */
    toggleActiveCategory( slug ) {

        // Remove active category classes.
        this.$galleryCategory.removeClass( 'active' );
        this.$galleryCategoryAll.removeClass( 'active' );

        // Add active category class.
        if ( ! slug ) {
            this.$galleryCategoryAll.addClass( 'active' );
        } else {
            $.each( this.$galleryCategory, ( key, value ) => {
                if ( $( value ).data( 'slug' ) === slug ) {
                    $( value ).addClass( 'active' );
                }
            });
        }
    }

    /**
     * Toggles load more button spinner state.
     */
    toggleLoadMoreBtn() {
        if ( this.$loadMoreText.is( ':visible' ) ) {
            this.$loadMoreText.hide();
            this.$loadMoreSpinner.css({ 'display': 'block' });
        } else if ( this.$loadMoreSpinner.is( ':visible' ) ) {
            this.$loadMoreSpinner.hide();
            this.$loadMoreText.css({ 'display': 'block' });
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.loadImagesByCategory( this.slug );
        this.toggleActiveCategory( this.slug );
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/gallery.js